import React from "react";
import styles from "./BookAppointment.module.css";
import BookingForm from "./Form";

const BookAppointment = ({ data }) => {
  return (
    <div className={`${styles.outer} bg-primary-500`}>
      <div className={styles.left}>
        {/* <div
          className={`oc-content oc-tileFlex bg-primary-500`}
          data-aos="fade-right"
          data-aos-delay="150"
        >
          <h1 className="oc-main-title">
            Getting the Most from Your Online Doctor Visit ?
          </h1>
          <div className="oc-tileDiv">
            <div className="oc-number">01</div>
            <div className="oc-tileDataDiv">
              <h2 className="oc-subtitle oc-fw-700 oc-m-0 oc-text-start ">
                Select a Specialist
              </h2>
              <h3 className="oc-description oc-m-0">
                Choose from a wide range of doctors tailored to your condition.
              </h3>
            </div>
          </div>
          <div className="oc-tileDiv">
            <div className="oc-number">02</div>
            <div className="oc-tileDataDiv">
              <h2 className="oc-subtitle oc-fw-700 oc-m-0 oc-text-start ">
                Book Your Appointment
              </h2>
              <h3 className="oc-description oc-m-0">
                Enter your details, get verified, and confirm your visit with a
                trusted doctor.
              </h3>
            </div>
          </div>
          <div className="oc-tileDiv">
            <div className="oc-number">03</div>
            <div className="oc-tileDataDiv">
              <h2 className="oc-subtitle oc-fw-700 oc-m-0 oc-text-start ">
                Free Follow-Up
              </h2>
              <h3 className="oc-description oc-m-0">
                Connect with a verified doctor, receive your e-prescription
                fast, and follow up at no extra cost.
              </h3>
            </div>
          </div>
        </div> */}
        <div
          className=""
          dangerouslySetInnerHTML={{ __html: data?.description }}
        ></div>
      </div>
      <div className={styles.right}>
        <BookingForm />
      </div>
    </div>
  );
};

export default BookAppointment;
